import { Box, Skeleton } from '@mui/material';

export const SectionPanelSkeleton = () => (
  <Box
    borderRadius="12px"
    border="1px solid #EAEAEA"
    mt={1}
    sx={{ background: 'white', padding: '24px' }}
    aria-hidden="true"
  >
    <Skeleton variant="text" width={160} height={28} sx={{ mb: 2 }} />
    <Skeleton variant="rounded" width="100%" height={120} />
  </Box>
);
